import { configureStore } from "@reduxjs/toolkit";
import searchReducer from "./Reducers/searchSlice";
import propertyReducer from "./Reducers/propertySlice";
import loaderReducer from "./Reducers/loadersSlice";
import authReducer from "./Reducers/authSlice";

import { setupListeners } from "@reduxjs/toolkit/query";

import { BookmarkApi } from "./Services/bookmarkApi";
import { LookupApi } from "./Services/lookupApi";
import { UserApi } from "./Services/userApi";

export const store = configureStore({
  reducer: {
    search: searchReducer,
    property: propertyReducer,
    loaders: loaderReducer,
    auth: authReducer,
    [BookmarkApi.reducerPath]: BookmarkApi.reducer,
    [LookupApi.reducerPath]: LookupApi.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      BookmarkApi.middleware,
      LookupApi.middleware,
      UserApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
